import Alpine from 'alpinejs'
import axios from 'axios'

Alpine.data('access_tokens', () => ({
    loading_tokens: true,
    initErrorMessage: null,
    tokens: [],
    createdToken: null,
    name: '',

    init() {
        this.loadTokens()
    },

    loadTokens() {
        axios.get('/tokens').then(res => {
            this.tokens = res.data
            this.loading_tokens = false
            return
        }).catch(err => {
            this.loading_tokens = false
            this.initErrorMessage = err.response.data.message
        })
    },

    copyToken(inputEl) {
        inputEl.focus();
        inputEl.select();
        document.execCommand('copy');

        setNotification({
            text: 'Token successfully copied.',
            notificationType: 'success'
        })
    },

    deleteToken(id){
        if(confirm('Are you sure ?')) {
            axios.delete(`/tokens/${id}`).then(res => {
                setNotification({
                    text: res.data.message,
                    notificationType: 'success'
                })

                return this.loadTokens()
            }).catch(err => {
                setNotification({
                    text: err.response.data.message,
                    notificationType: 'error'
                })
            })
        }
    },

    submit() {
        this.createdToken = null
        axios.post('/tokens', {
            name: this.name
        }).then(res => {
            this.loadTokens()
            this.createdToken = res.data.token
            this.name = ''

            setNotification({
                text: res.data.message,
                notificationType: 'success'
            })
        })
    }
}))